module.exports = __webpack_public_path__ + "static/media/za.a57b9a59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/za.svg
// module id = 293
// module chunks = 0